import MetalClient, { envTypes } from '@atlassiansox/metal-client';
import { getMicrosEnv } from '@atlassian/temp-shared';

export const PPC_METAL_CLIENT_ID = 'acbb4dbb-6463-4095-97de-4473f9c6605d';

export const METAL_ENV = (() => {
  switch (getMicrosEnv()) {
    case 'prod-east':
      return envTypes.PROD;
    case 'adev':
      return envTypes.DEV;
    case 'stg-east':
      return envTypes.STAGING;
    default:
      return envTypes.LOCAL;
  }
})();

export const metalClient = new MetalClient({
  productInfo: {
    metalId: PPC_METAL_CLIENT_ID,
    env: METAL_ENV,
    version: '1.0.0',
  },
});
